module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_5.43704ae6.png";